module.exports = __webpack_public_path__ + "img/img0.b75a0446.jpg";